<template>
  <!--底部地图切换 -->
  <div class="rightmenu">
    <div class="toolbar">
      <a
        href="###"
        class="toolbar-item toolbar-item-service toolbar-item-weixin"
      >
        <span class="toolbar-layer"></span>
      </a>
      <el-badge
        :value="this.productcontent.length"
        class="item"
      >
        <a
          href="###"
          class="toolbar-item toolbar-item-feedback"
          @click="opencart"
        ></a>
      </el-badge>
      <a
        href="###"
        class="toolbar-item toolbar-item-change"
        @click="opentuceng"
      >
        <span class="toolbar-layer"></span>
      </a>
      <el-tooltip placement="left-start">
        <a
          href="###"
          class="toolbar-item toolbar-item-app"
        >
          <span class="toolbar-layer"></span>
        </a>
        <div
          class="dtdiv"
          ref="showdtdiv"
          slot="content"
        >
          <div
            class="tcdt"
            @click="switchtc('vec_c')"
          >
            <div style="width: 50px;height: 50px;"><img
                width="100%"
                src="../../assets/images/vec_c.png"
                height="100%"
              /></div>
            <div style="position: absolute;top: 35px;width: 50px;
    color: #fff;
    font-size: 12px;    background-color: #ccc;">矢量</div>
          </div>
          <div
            class="tcdt"
            @click="switchtc('img_c')"
          >
            <div style="width: 50px;height: 50px;"><img
                width="100%"
                src="../../assets/images/img_c.png"
                height="100%"
              /></div>
            <div style="position: absolute;top: 35px;width: 50px;
    color: #fff;
    font-size: 12px;    background-color: #ccc;">影像</div>
          </div>
          <div
            class="tcdt"
            @click="switchtc('ter_c')"
          >
            <div style="width: 50px;height: 50px;"><img
                width="100%"
                src="../../assets/images/ter_c.png"
                height="100%"
              /></div>
            <div class="swdivfont">地形</div>
          </div>
        </div>
      </el-tooltip>
      <a
        href="javascript:scroll(0,0)"
        id="top"
        @click="setin"
        class="toolbar-item toolbar-item-top"
      ></a>
      <a
        href="javascript:scroll(0,0)"
        id="top"
        @click="setout"
        class="toolbar-item toolbar-item-top1"
      ></a>
    </div>
    <head-product-cart-dialog
      :prodata="productcontent"
      :msg-father="ProductContentdialogFormVisible"
      :checkAll="checkAll"
      v-on:sendclearall="sendclearall"
      v-on:getproductcartdialogFormVisible="getProductcontentDialogMsg"
      v-on:updateProductContent="updateProductContent"
    >
    </head-product-cart-dialog>

    <head-product-tu-ceng-dialog
      :prodata="producttuceng"
      :msg-father="ProductTuCengdialogFormVisible"
      v-on:sendclearalltc="sendclearalltc"
      v-on:getproducttucengdialogFormVisible="getProductTuCengDialogMsg"
    >
    </head-product-tu-ceng-dialog>
  </div>
</template>
<script>
import HeadProductCartDialog from './HeadProductCartDialog'
import HeadProductTuCengDialog from './HeadProductTuCengDialog'
import Map from '../../common/map/Tmap.js'
export default {
  props: ['prodata', 'tcprodata', 'checkAll'],
  name: 'RightMenu',
  components: {
    HeadProductCartDialog,
    HeadProductTuCengDialog
  },
  data () {
    return {
      ProductContentdialogFormVisible: false,
      ProductTuCengdialogFormVisible: false,
      productcontent: [],
      producttuceng: [],
      showtc: false
    }
  },
  created () {
    this.productcontent = this.prodata
    this.producttuceng = this.tcprodata
    if (this.$route.params.cartOpen) {
      this.opencart()
    }
  },
  methods: {
    setin () {
      Map.setZoomin()
    },
    setout () {
      Map.setZoomout()
    },
    switchtc (val) {
      Map.SwitchLayer(val)
    },
    sendclearall (val) {
      this.$emit('sendclearall', val)
    },
    updateProductContent (val) {
      this.productcontent = val
    },
    sendclearalltc (val) {
      console.log('清空图层')
      this.$emit('sendclearalltc', val)
    },
    opencart () {
      this.ProductContentdialogFormVisible = true
      this.ProductTuCengdialogFormVisible = false
    },
    getProductcontentDialogMsg (msg) {
      console.log(msg)
      this.ProductContentdialogFormVisible = msg
    },
    opentuceng () {
      this.ProductTuCengdialogFormVisible = true
      this.ProductContentdialogFormVisible = false
    },
    getProductTuCengDialogMsg (msg) {
      console.log(msg)
      this.ProductTuCengdialogFormVisible = msg
    }
  },
  watch: {
    tcprodata (data) {
      this.producttuceng = data
    },
    prodata (data) {
      this.productcontent = data
    }
  }
}
</script>
<style>
.swdivfont {
  position: absolute;
  top: 35px;
  width: 50px;
  color: #fff;
  font-size: 12px;
  background-color: #ccc;
}
.dtdiv {
  right: 0px;
  width: 170px;
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.el-tooltip__popper .popper__arrow {
  display: none;
}
.tcdt {
  cursor: pointer;
  width: 50px;
  height: 50px;
  padding: 0px;
  text-align: center;
}
.toolbar-item,
.toolbar-layer {
  background: url(../../assets/images/toolbar.png) no-repeat;
}
.toolbar .el-badge__content.is-fixed {
  position: absolute;
  top: 5px;
  right: 60px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
.toolbar {
  position: fixed;
  right: 0px;
  bottom: 35%;
  margin-right: 5px;
} /*假设网页宽度为1200px，导航条在右侧悬浮*/
.toolbar-item {
  display: block;
  width: 52px;
  height: 52px;
  margin-top: 2px;
  position: relative;
  -moz-transition: background-position 1s;
  -ms-transition: background-position 1s;
  -o-moz-transition: background-position 1s;
  -webkit-moz-transition: background-position 1s;
  transition: background-position 1s;
}
.toolbar-item-service {
  background-position: 0 -798px;
}
.toolbar-item-weixin {
  background-position: 0 -798px;
}

.toolbar-item-weixin:hover {
  background-position: 0 -860px;
}

.toolbar-item-weixin .toolbar-layer {
  height: 212px;
  background-position: 0 0;
}

.toolbar-item-feedback {
  background-position: 0 -426px;
}

.toolbar-item-feedback:hover {
  background-position: 0 -488px;
}

.toolbar-item-app {
  background-position: 0 -550px;
}

.toolbar-item-app:hover {
  background-position: 0 -612px;
}
.toolbar-item-change {
  background-position: 0 -303px !important;
}

.toolbar-item-change:hover {
  background-position: 0 -364px !important;
}
.toolbar-item-service .toolbar-layer {
  height: 212px;
  background-position: 0 0;
}

.toolbar-item-feedback {
  background-position: 0 -426px;
}
.toolbar-item-app {
  background-position: 0 -550px;
}
.toolbar-item-app .toolbar-layer {
  height: 194px;
  background-position: 0 -222px;
}
.toolbar-item-top {
  background-position: 0 -674px;
}
.toolbar-item-top:hover {
  background-position: 0 -737px;
}

.toolbar-item-top1 {
  background-position: 0 -923px;
}
.toolbar-item-top1:hover {
  background-position: 0 -986px;
}
.toolbar-layer {
  position: absolute;
  right: 46px;
  bottom: -10px;
  width: 172px;
  opacity: 0;
  filter: alpha(opacity=0);
  transform-origin: 95% 95%;
  -moz-transform-origin: 95% 95%;
  -ms-transform-origin: 95% 95%;
  -o-transform-origin: 95% 95%;
  -webkit-transform-origin: 95% 95%;
  transform: scale(0.01);
  -moz-transform: scale(0.01);
  -ms-transform: scale(0.01);
  -o-transform: scale(0.01);
  -webkit-transform: scale(0.01);
  transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  -webkit-transition: all 1s;
}
.el-tooltip__popper {
  position: absolute;
  border-radius: 4px;
  padding: 0px;
  z-index: 2000;
  font-size: 12px;
  line-height: 1.2;
  min-width: 10px;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/RightMenu/RightMenu.vue